import React, { Component } from 'react';
import BotListPage from './Components/BotListPage.js';
import CommentListPage from './Components/CommentListPage.js';
import UserCommentListPage from './Components/UserCommentListPage.js';
import axios from 'axios';
import CommentPage from './Components/CommentPage.js';
import './css/style.css';
import MessagePage from './Components/MessagePage.js';
import BotMarketPanel from './Components/BotMarketPanel';

export default class BOTInteractManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            recording: null,
            giftList: [],
            loadRecording: false,
            isComponentUpdate: true,
            loadRecording: false,
            showCommentList: false,
            showBotCommentList: false,
            showMessageList: false,
            selectedBotParam: null,
            user: null,
            activeTab: "manage",
            market: "VN"
        };

        this.getRecording = this.getRecording.bind(this);
        this.handleBotClick = this.handleBotClick.bind(this);
        this.handleBotClickUserComment = this.handleBotClickUserComment.bind(this);
        this.handleBotClickMessage = this.handleBotClickMessage.bind(this);
        this.changePageMode = this.changePageMode.bind(this);
    }

    renderPanelPlaceholder(message, icon = "fa-regular fa-eye") {
        return (
            <div className="panel-placeholder">
                <i className={icon}></i>
                <p>{message}</p>
            </div>
        );
    }

    renderCommentMode() {
        const { showCommentList, recording, giftList, user, selectedBotParam } = this.state;
        return (
            <div className="panel-layout">
                <section className="panel-card panel-card--sidebar">
                    <div className="panel-card-body panel-card-body--scroll">
                        <BotListPage key={this.state.market} market={this.state.market}
                            standalone={false}
                            onBotClick={this.handleBotClick}
                        ></BotListPage>
                    </div>
                </section>
                <div className="panel-column">
                    <section className="panel-card panel-card--feed">
                        <div className="panel-card-header">
                            <div>
                                <p className="panel-label">Luồng bình luận</p>
                            </div>
                        </div>
                        <div className="panel-card-body panel-card-body--scroll">
                            {showCommentList ? (
                                <CommentListPage
                                    param={selectedBotParam}
                                    onCommentClick={this.getRecording}
                                />
                            ) : this.renderPanelPlaceholder("Chọn một BOT để xem danh sách bình luận!")}
                        </div>
                    </section>
                    <section className="panel-card panel-card--detail">
                        <div className="panel-card-header">
                            <div>
                                <p className="panel-label">Nội dung chi tiết</p>
                            </div>
                        </div>
                        <div className="panel-card-body panel-card-body--scroll">
                            {recording ? (
                                <CommentPage
                                    user={user}
                                    giftList={giftList}
                                    recording={recording}
                                    noCommentPerRequest={5}
                                ></CommentPage>
                            ) : this.renderPanelPlaceholder("Chọn một bình luận để xem chi tiết!", "fa-regular fa-comments")}
                        </div>
                    </section>
                </div>
            </div>
        );
    }

    renderCommentUserMode() {
        const { showBotCommentList, recording, giftList, user, selectedBotParam } = this.state;
        return (
            <div className="panel-layout">
                <section className="panel-card panel-card--sidebar">
                    <div className="panel-card-body panel-card-body--scroll">
                        <BotListPage key={this.state.market} market={this.state.market}
                            standalone={false}
                            mode={"commentuserPage"}
                            onBotClick={this.handleBotClickUserComment}
                        ></BotListPage>
                    </div>
                </section>
                <div className="panel-column">
                    <section className="panel-card panel-card--feed">
                        <div className="panel-card-header">
                            <div>
                                <p className="panel-label">Luồng bình luận</p>
                            </div>
                        </div>
                        <div className="panel-card-body panel-card-body--scroll">
                            {showBotCommentList ? (
                                <UserCommentListPage
                                    param={selectedBotParam}
                                    onCommentClick={this.getRecording}
                                />
                            ) : this.renderPanelPlaceholder("Chọn BOT để xem bình luận của người dùng")}
                        </div>
                    </section>
                    <section className="panel-card panel-card--detail">
                        <div className="panel-card-header">
                            <div>
                                <p className="panel-label">Nội dung chi tiết</p>
                            </div>
                        </div>
                        <div className="panel-card-body panel-card-body--scroll">
                            {recording ? (
                                <CommentPage
                                    user={user}
                                    giftList={giftList}
                                    recording={recording}
                                    noCommentPerRequest={5}
                                ></CommentPage>
                            ) : this.renderPanelPlaceholder("Hãy chọn bài thu để xem chi tiết!")}
                        </div>
                    </section>
                </div>
            </div>
        );
    }

    renderMessageMode() {
        const { showMessageList, selectedBotParam } = this.state;
        return (
            <div className="panel-grid panel-grid-two">
                <section className="panel-card">
                    <div className="panel-card-body panel-card-body--scroll">
                        <BotListPage key={this.state.market} market={this.state.market} standalone={false} mode={"messagePage"} onBotClick={this.handleBotClickMessage}></BotListPage>
                    </div>
                </section>
                <section className="panel-card panel-card--message">
                    <div className="panel-card-body panel-card-body--flush">
                        {showMessageList ? (
                            <MessagePage market={this.state.market}
                                param={selectedBotParam}
                            />
                        ) : this.renderPanelPlaceholder("Chọn một BOT để xem danh sách người dùng nhắn tin với BOT!", "fa-regular fa-envelope")}
                    </div>
                </section>
            </div>
        );
    }

    handleBotClick(param) {
        this.setState({
            showCommentList: true,
            selectedBotParam: param,
            user: {
                "facebookId": param,
                "level": 2
            },
            recording: null
        });
    }

    handleBotClickUserComment(param) {
        this.setState({
            showBotCommentList: true,
            selectedBotParam: param,
            user: {
                "facebookId": param,
                "level": 2
            },
            recording: null
        });
    }

    handleBotClickMessage(param) {
        this.setState({
            showMessageList: true,
            selectedBotParam: param
        });
    }

    getRecording(recordid) {
        var recordingId = recordid;
        const json = JSON.stringify({ domain: window.location.hostname, recordingId: recordingId });

        axios.post(global.config.apiDomain + '/rest/recordingpage', json, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            const { error, recording, gifts } = res.data;
            this.setState(
                {
                    recording: recording,
                    giftList: gifts,
                    error: error,
                    loadRecording: true
                });
        })
    }

    refreshPage() {
        window.location.reload();
    }

    changePageMode(mode) {
        this.setState({
            activeTab: mode,
            recording: null,      // clear nội dung chi tiết khi đổi tab
            giftList: [],
            loadRecording: false
        });
    }


    render() {
        const { selectedBotParam, activeTab } = this.state;
        const tabOptions = [
            { key: "manage", label: "Quản lý thị trường", description: "Pool BOT, nội dung mẫu, prompt và lịch hoạt động" },
            { key: "message", label: "Tin nhắn", description: "Theo dõi trao đổi giữa BOT và người dùng" },
            { key: "comment", label: "Bình luận của BOT", description: "Xem bình luận của BOT gửi tới bài thu của người dùng" },
            { key: "commentuserPage", label: "Bài thu của BOT", description: "Xem bình luận của người dùng gửi tới bài thu của BOT" }
        ];

        return (
            <div className="bot-admin-shell">
                <section className="bot-admin-hero">
                    <div>
                        <h1>QUẢN LÍ TƯƠNG TÁC BOT</h1>
                    </div>
                    <div className="bot-hero-actions">
                        <label>Thị trường <select aria-label="Thị trường BOT" value={this.state.market} onChange={event => this.setState({market: event.target.value, selectedBotParam:null, recording:null, showMessageList:false, showCommentList:false, showBotCommentList:false})}>
                            <option value="VN">Việt Nam · IKARA / YOKARA</option><option value="PH">Philippines · YOSING</option>
                        </select></label>
                        <div className="selected-bot-pill">
                            <span className="pill-label">BOT đang xem</span>
                            <strong>{selectedBotParam || "Chưa chọn"}</strong>
                        </div>
                    </div>
                </section>

                <div className="tab-strip">
                    {tabOptions.map(tab => (
                        <button
                            key={tab.key}
                            className={`tab-pill ${activeTab === tab.key ? "active" : ""}`}
                            onClick={() => this.changePageMode(tab.key)}
                        >
                            <span>{tab.label}</span>
                            <small>{tab.description}</small>
                        </button>
                    ))}
                </div>

                {activeTab === "manage" && <BotMarketPanel key={this.state.market} market={this.state.market}/>}
                {activeTab === "comment" && this.renderCommentMode()}
                {activeTab === "commentuserPage" && this.renderCommentUserMode()}
                {activeTab === "message" && this.renderMessageMode()}
            </div>
        );
    }
}
